import StringMax from "./StringMax.vue"

export default StringMax
